import "./sentry";
import React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
ReactDOM.render(React.createElement(App, null), document.getElementById("root"));
